<div class="modal-header">
    <h5 *ngIf="fromParent.err.id === 'modal-timeout'" class="design-modal-title">
        {{ 'app.global.modals.wizard-ia-modal-error-timeout-title' | translate }}
    </h5>
    <h5 *ngIf="fromParent.err.id !== 'modal-timeout'" class="design-modal-title">
        {{ 'app.global.modals.wizard-ia-modal-error-token-title' | translate }}
    </h5>
</div>
<div class="card-body">
    <div class="mt-2">
        <p *ngIf="fromParent.err.id === 'modal-timeout'" class="description">
            {{ 'app.global.modals.wizard-ia-modal-error-timeout' | translate }}
        </p>
        <p *ngIf="fromParent.err.id !== 'modal-timeout'" class="description">
            {{ 'app.global.modals.wizard-ia-modal-error-token' | translate }}
        </p>
    </div>
</div>
<div class="modal-footer">
    <div class="text-right">
        <button class="btn btn-continue" (click)="save()">
            {{ 'app.global.modals.entiendo' | translate }}
        </button>
    </div>
</div>
